import { ChevronsUpDown } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconChevronUpDown(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <ChevronsUpDown />
    </IconWrapper>
  );
}
